import React from 'react';
import ReactDOM from 'react-dom';
import WeatherApp from './App';

ReactDOM.render(
  <React.StrictMode>
    <WeatherApp />
  </React.StrictMode>,
  document.getElementById('root')
);
